/* ============================================================
   OFFER LOGIC (Metafield-based)
   ============================================================ */

function applyOffers(context = document) {
  const anchors = context.querySelectorAll("[data-offers-target]");
  if (!anchors.length) return;

  anchors.forEach(anchor => {
    if (anchor.dataset.offersApplied === "true") return;

    const promoText = anchor.getAttribute("data-promo-text");

    if (promoText) {
      const isPDP = anchor.hasAttribute("data-pdp");

      anchor.innerHTML = isPDP
        ? `<div class="offer-stack">${renderOfferTemplate(promoText)}</div>`
        : renderOfferTemplate(promoText);
    }

    anchor.dataset.offersApplied = "true";
  });
}

/* ============================================================
   INITIAL LOAD
   ============================================================ */

document.addEventListener("DOMContentLoaded", () => {
  applyOffers();
});

/* ============================================================
   DYNAMIC CONTENT (AJAX / SECTIONS)
   ============================================================ */

const offerObserver = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;

      if (node.matches?.("[data-offers-target]")) {
        applyOffers(node.parentElement || document);
      } else if (node.querySelector?.("[data-offers-target]")) {
        applyOffers(node);
      }
    });
  });
});

offerObserver.observe(document.body, {
  childList: true,
  subtree: true
});

/* ============================================================
   RENDER
   ============================================================ */

function renderOfferTemplate(text) {
  const tpl = document.getElementById("offer-line-template");
  if (!tpl || !text) return "";
  return tpl.innerHTML.replace("{{offer_text}}", text);
}
